<h1 *ngIf="isMainHeading()" [class]="getMainHeadingClasses()" [innerHTML]="text | translate"></h1>

<h2 *ngIf="!isMainHeading()" [class]="getHeadingClasses()" [innerHTML]="text | translate"></h2>
